import { computed, ref } from 'vue';
import { BRAND, USER } from '@/models/auth/permissions.enum';
import { usePlatformStore } from '@/stores/platform';
import { useIdentityStore } from '@/stores/identity';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';

export function useTikTokCreatorMarketplace(brand) {
  const platformType = PLATFORM_CONNECTION.TIKTOK_CREATOR_MARKETPLACE;

  const platformStore = usePlatformStore();
  const identityStore = useIdentityStore();

  const brandToConnect = ref(brand.value ?? identityStore.currentBrand);
  const brandId = ref(brandToConnect.value.id);

  const platformConnection = computed(() =>
    platformStore.getPlatformConnection(platformType, {
      brandId: brandId.value,
    }),
  );
  // computed
  const hasValidPlatformConnection = computed(() =>
    platformStore.isPlatformConnected(platformType.value, { brandId: brandToConnect.value.id }),
  );
  const canManageTTCM = computed(() => {
    const userCanAccessCreators = identityStore.guard(
      USER.CREATORS.CAN_ACCESS_CREATORS,
      brandToConnect.value,
    );
    const brandCanAccessCreators = identityStore.guard(
      BRAND.CREATORS.CAN_ACCESS_CREATORS,
      brandToConnect.value,
    );
    return brandCanAccessCreators && userCanAccessCreators;
  });
  const canEnableAccounts = computed(() => canManageTTCM.value);
  const canConnect = computed(() => canManageTTCM.value || hasValidPlatformConnection.value);
  const hasMonitoredTTCMAccount = computed(() => {
    const accounts = platformStore.accounts[platformType.value]?.[brandId.value] || [];
    return accounts.some((account) => account.isMonitored);
  });

  return {
    brandToConnect,
    brandId,
    platformConnection,
    hasMonitoredTTCMAccount,
    hasValidPlatformConnection,
    canManageTTCM,
    canEnableAccounts,
    canConnect,
  };
}
